import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import { OidcService } from '../oidc/oidc.service';
import { PartnerService } from '../shared/utils/partner.service';
import {ApiRegistrationService} from '../shared/api/api.registration.service';
import { QueryParam } from '../shared/models/queryParams';
import { LocalStorageKey } from '../shared/models/localStorageKeys';
import {Store} from "@ngrx/store";
import AppState from "../store";
import {selectUserProfile} from "../store/userProfile/userProfile.selector";
import {take} from "rxjs/operators";

/**
 * Class that redirects a user to /dashboard/home if he was still logged in and navigated to /login
 */
@Injectable()
export class LoginGuardService implements CanActivate {

  constructor(
    private oidcService: OidcService,
    private router: Router,
    private partnerService: PartnerService,
    private apiRegistrationService: ApiRegistrationService,
    private store: Store<AppState>
  ) {
  }

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    const userProfile = await this.store.select(selectUserProfile).pipe(take(1)).toPromise();
    const userId = userProfile?.userId;

    this.setQuestionnaireId(route, userId);
    this.setHealthPlazaEventId(route);

    if (this.oidcService.isAuthenticated()) {
      const incompleteRegistrationSteps = await this.apiRegistrationService.getIncompleteRegistrationSteps();
      if(incompleteRegistrationSteps && route.url[0]?.path === 'register') {
        return true;
      }
      if (this.partnerService.isPartnerVital10()) {
        if (state.url.indexOf('partner') !== -1 || state.url.indexOf('login-vital10') !== -1) {
          return true;
        } else {
          return false;
        }
      }
      return this.router.parseUrl('/dashboard/home');
    }
    return true;
  }

  private setQuestionnaireId(route: ActivatedRouteSnapshot, userId?: string) {
    const questionnaireId = route.queryParamMap.get(QueryParam.QUESTIONNAIRE_ID);

    if(questionnaireId) {
      localStorage.setItem(`${LocalStorageKey.QUESTIONNAIRE_ID}-${userId}`, questionnaireId);
    }
  }

  private setHealthPlazaEventId(route: ActivatedRouteSnapshot) {
    const healthPlazaEventId = route.queryParamMap.get(QueryParam.HEALTH_PLAZA_EVENT_ID);

    if(healthPlazaEventId) {
      localStorage.setItem(LocalStorageKey.HEALTH_PLAZA_EVENT_ID, healthPlazaEventId);
    }
  }
}
